import createCrudModule from '@/utils/createCrudModule'

export default createCrudModule({
  resource: 'news',
  urlRoot: '/news'
})
